import { DatePicker } from "antd";
import { ChevronUp, Info } from "feather-icons-react/build/IconComponents";
import ArrowLeft from "feather-icons-react/build/IconComponents/ArrowLeft";
import React, { useEffect, useState } from "react";
import { PlusCircle } from "react-feather";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import { all_routes } from "../../Router/all_routes";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { setToogleHeader } from "../../core/redux/action";
import { useDispatch, useSelector } from "react-redux";
import { getEmployeeById, updateEmployee } from "../../service/ApiServices";
import dayjs from "dayjs";

const EditEmployee = () => {
  const route = all_routes;
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const location = useLocation();
  const navigate = useNavigate();
  const selectedEmployeeId = location.state.employeeId;
  // console.log(selectedEmployeeId);

  // fetch shift details and set it to options
  const [shiftOptions, setShiftOptions] = useState([]);

  useEffect(() => {
    fetch("http://localhost:8000/api/shifts")
      .then(response => response.json())
      .then(data => {
        // console.log(data);
        const processedShiftOptions = data.data.shifts.map(item => ({
          value: item._id,
          label: item.shiftInfo.shiftName
        }));
        setShiftOptions(processedShiftOptions);
      })
      .catch(error => console.error('Error fetching shifts:', error));
  }, []);

  // fetch designation details and set it to options
  const [designationOptions, setDesignationOptions] = useState([]);

  useEffect(() => {
    fetch("http://localhost:8000/api/designations")
      .then(response => response.json())
      .then(data => {
        // console.log(data);
        const processedDesignationOptions = data.data.designations.map(item => ({
          value: item._id,
          label: item.designationName 
        }));
        setDesignationOptions(processedDesignationOptions);
      })
      .catch(error => console.error('Error fetching designations:', error));
  }, []);

  // fetch department details and set it to options
  const [departmentOptions, setDepartmentOptions] = useState([]);

  useEffect(() => {
    fetch("http://localhost:8000/api/departments")
      .then(response => response.json())
      .then(data => {
        console.log(data);
        const processedDepartmentOptions = data.data.departments.map(item => ({
          value: item._id,
          label: item.departmentName 
        }));
        setDepartmentOptions(processedDepartmentOptions);
      })
      .catch(error => console.error('Error fetching department:', error));
  }, []);

  // fetch country name and set it to country option
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await fetch('https://restcountries.com/v3.1/all');
        const data = await response.json();
        // console.log(data);
        const processedCountryOptions = data.map(country => ({
          value: country.name.common,
          label: country.name.common
        }));
        setCountries(processedCountryOptions);
      } catch (error) {
        console.error('Error fetching countries:', error);
      }
    };

    fetchCountries();
  }, []);

  // fetch nationalities and set to country option
  const [nationalitiesOptions, setNationality] = useState([]);

  useEffect(() => {
    const fetchNationalities = async () => {
      try {
        const response = await fetch('https://restcountries.com/v3.1/all');
        const data = await response.json();
        const nationalities = data.reduce((acc, country) => {
          if (country.demonyms && country.demonyms.eng) {
            acc.push(country.demonyms.eng.m);
            acc.push(country.demonyms.eng.f);
          }
          return acc;
        }, []);
        const uniqueNationalities = [...new Set(nationalities)];
        const processedNationalityOptions = uniqueNationalities.map(nationality => ({
          value: nationality,
          label: nationality
        }));
        setNationality(processedNationalityOptions);
      } catch (error) {
        console.error('Error fetching nationalities:', error);
      }
    };

    fetchNationalities();
  }, []);

  const [formData, setFormData] = useState({
    fullName: '',
    firstName: '',
    lastName: '',
    email: '',
    contactNumber: '',
    epfNumber: '',
    nic: '',
    dateOfBirth: null,
    gender: '',
    nationality: '',
    joiningDate: null,
    shiftId: '',
    departmentId: '',
    designationId: '',
    bloodGroup: '',
    emergencyNo1: '',
    emergencyNo2: '',
    address: '',
    country: '',
    state: '',
    city: '',
    zipcode: '',
    bankName: '',
    bankCode: '',
    bankBranch: '',
    bankBranchCode: '',
    accountHolderName: '',
    accountNumber: '',
    password: '',
    profilePicture: null,
    // Mandatory fields added
    branch: '',
    employeeType: '',
    payFrequency: '',
  });


  const setSelectedEmployee = async (selectedEmployeeId) => {
    try {
      const response = await getEmployeeById(selectedEmployeeId);
      // console.log(response.data.employee);
      // const employee = response.data.employee;
      // const parsedDateOfBirth = employee.dateOfBirth.split('T')[0];
      // console.log(parsedDateOfBirth);
      // const parsedJoiningDate = employee.joiningDate.split('T')[0];
      if (response.data) {
        const emp = response.data.employee;
        setFormData((prev) => ({
          ...prev,
          fullName: emp.full_name || '',
          firstName: emp.first_name || '',
          lastName: emp.last_name || '',
          email: emp.email || '',
          contactNumber: emp.contact_number || '',
          epfNumber: emp.epf_number || '',
          nic: emp.nic || '',
          dateOfBirth: emp.date_of_birth ? new Date(emp.date_of_birth) : null,
          gender: emp.gender || '',
          nationality: emp.nationality || '',
          joiningDate: emp.joining_date ? new Date(emp.joining_date) : null,
          shiftId: emp.shift?._id || emp.shift || '',
          departmentId: emp.department_id || '',
          designationId: emp.designation_id || '',
          bloodGroup: emp.blood_group || '',
          emergencyNo1: emp.emergency_no_1 || '',
          emergencyNo2: emp.emergency_no_2 || '',
          address: emp.address || '',
          country: emp.country || '',
          state: emp.province || '',
          city: emp.city || '',
          zipcode: emp.zipcode || '',
          bankName: emp.bank || emp.bankName || '',
          bankCode: emp.bank_code || '',
          bankBranch: emp.bank_branch || '',
          bankBranchCode: emp.branch_code || emp.bank_branch_code || '',
          accountHolderName: emp.account_holder || '',
          accountNumber: emp.account_number || '',
          // Mandatory fields
          branch: emp.branch || '',
          employeeType: emp.employee_type || '',
          payFrequency: emp.pay_frequency || '',
          password: '',
        }));  
      } else {
        console.error("Failed to fetch employee data");
      }
    } catch (error) {
      console.error("Error fetching employee data:", error);
    }
  };


  useEffect(() => {
    if (selectedEmployeeId) {
      setSelectedEmployee(selectedEmployeeId);
    }
  }, []);


  // const [selectedDate, setSelectedDate] = useState(new Date());
  // const handleDateChange = (date) => {
  //   setSelectedDate(date);
  // };
  // const [selectedDate1, setSelectedDate1] = useState(new Date());
  // const handleDateChange1 = (date) => {
  //   setSelectedDate1(date);
  // };
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };
  const [showConfirmPassword, setConfirmPassword] = useState(false);
  const handleToggleConfirmPassword = () => {
    setConfirmPassword((prevShowPassword) => !prevShowPassword);
  };
  const gender = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
  ];
  const nationality = [
    // { value: "United Kingdom", label: "United Kingdom" },
    // { value: "India", label: "India" },
    ...nationalitiesOptions
  ];
  const shifts = [
    // { value: "Regular", label: "Regular" },
    ...shiftOptions
  ];
  const departments = [
    // { value: "UI/UX", label: "UI/UX" },
    // { value: "Support", label: "Support" },
    // { value: "HR", label: "HR" },
    // { value: "Engineering", label: "Engineering" },
    ...departmentOptions
  ];
  const designation = [
    // { value: "Designer", label: "Designer" },
    // { value: "Developer", label: "Developer" },
    // { value: "Tester", label: "Tester" },
    ...designationOptions
  ];
  const bloodgroup = [
    // { value: "Select", label: "Select" },
    { value: "A+", label: "A+" },
    { value: "A-", label: "A-" },
    { value: "B+", label: "B-" },
    { value: "O+", label: "O-" },
    { value: "O+", label: "O-" },
    { value: "AB+", label: "AB-" },
    { value: "AB+", label: "AB-" },
  ];
  const country = [
    // { value: "United Kingdom", label: "United Kingdom" },
    // { value: "USA", label: "USA" },
    ...countries
  ];
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const handleChange = (event, fieldOverride) => {
    const { name, value, type } = event.target;
    const key = fieldOverride || name;
    let newValue = value;

    if (type === 'file') {
      newValue = event.target.files[0];
    } else if (type === 'date') {
      const selectedDate = new Date(value);
      newValue = new Date(
        selectedDate.getFullYear(),
        selectedDate.getMonth(),
        selectedDate.getDate()
      );
    } else if (key === 'nic') {
      if (value === '' || /^[0-9VXvx\s]+$/.test(value)) {
        newValue = value.replace(/\s+/g, '').toUpperCase();
      } else {
        return;
      }
    } else if (key === 'contactNumber' || key === 'emergencyNo1' || key === 'emergencyNo2' || key === 'accountNumber' || key === 'bankCode' || key === 'bankBranchCode' || key === 'zipcode') {
      if (value === '' || /^\d+$/.test(value)) {
        newValue = value;
      } else {
        return;
      }
    }

    setFormData({
      ...formData,
      [key]: newValue,
    });
  };

  const handleSelectChange = (selectedOption, name) => {
    setFormData({
      ...formData,
      [name]: selectedOption ? selectedOption.value : '',
    });
    if (errors[name]) {
      setErrors((prev) => { const e = { ...prev }; delete e[name]; return e; });
    }
  };

  const handleDateChange = (date, dateString, fieldName) => {
    setFormData({
      ...formData,
      [fieldName]: date ? date.toDate() : null,
    });
  };

  const [confirmPassword, setConfPassword] = useState('');
  const [passwordsMatch, setPasswordsMatch] = useState(true);
  const [errors, setErrors] = useState({});

  // Options for new mandatory fields
  const branchOptions = [
    { value: 'wattala', label: 'Wattala' },
    { value: 'negombo', label: 'Negombo' },
    { value: 'kaduwela', label: 'Kaduwela' },
    { value: 'kiribathgoda', label: 'Kiribathgoda' },
    { value: 'kandana', label: 'Kandana' },
    { value: 'delgoda', label: 'Delgoda' },
    { value: 'lsu', label: 'Wattala LSU' },
    { value: 'cityschool', label: 'City School - Negombo' },
  ];
  const employeeTypeOptions = [
    { value: 'Academic', label: 'Academic' },
    { value: 'Non Academic', label: 'Non Academic' },
  ];
  const payFrequencyOptions = [
    { value: 'Monthly', label: 'Monthly' },
    { value: 'Weekly', label: 'Weekly' },
    { value: 'Daily', label: 'Daily' },
    { value: 'annually', label: 'Annually' },
  ];

  const errBorder = (field) =>
    errors[field]
      ? { border: '1px solid #dc3545', borderRadius: '4px', padding: '1px' }
      : {};

  const handleConfirmPasswordChange = (event) => {
    setConfPassword(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setFormData({ ...formData, password: event.target.value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Collect ALL validation errors at once
    const errs = {};
    if (!formData.gender || formData.gender === '' || formData.gender === 'Choose')
      errs.gender = 'Gender is required.';
    if (!formData.branch)
      errs.branch = 'Branch is required.';
    if (!formData.employeeType)
      errs.employeeType = 'Employee Type is required.';
    if (!formData.payFrequency)
      errs.payFrequency = 'Pay Frequency is required.';

    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      // Show first error as toast for quick feedback
      toast.error(Object.values(errs)[0]);
      return;
    }
    setErrors({});

    if (formData.password !== confirmPassword) {
      setPasswordsMatch(false);
      toast.error("Passwords don't match");
      return;
    }
    setPasswordsMatch(true);

    const formDataToSend = new FormData();
    const appendIfValue = (key, value) => {
      if (value !== undefined && value !== null && value !== '') {
        formDataToSend.append(key, value);
      }
    };

    const dobValue = formData.dateOfBirth ? new Date(formData.dateOfBirth).toISOString() : '';
    const joinValue = formData.joiningDate ? new Date(formData.joiningDate).toISOString() : '';

    appendIfValue('full_name', formData.fullName || `${formData.firstName} ${formData.lastName}`.trim());
    appendIfValue('first_name', formData.firstName);
    appendIfValue('last_name', formData.lastName);
    appendIfValue('email', formData.email);
    appendIfValue('contactNumber', formData.contactNumber);
    appendIfValue('contact_number', formData.contactNumber);
    appendIfValue('epf_number', formData.epfNumber);
    appendIfValue('epfNumber', formData.epfNumber);
    appendIfValue('nic', formData.nic);
    appendIfValue('date_of_birth', dobValue);
    appendIfValue('dateOfBirth', dobValue);
    appendIfValue('gender', formData.gender);
    appendIfValue('nationality', formData.nationality);
    appendIfValue('joining_date', joinValue);
    appendIfValue('joiningDate', joinValue);
    appendIfValue('shiftId', formData.shiftId);
    appendIfValue('shift', formData.shiftId);
    appendIfValue('department_id', formData.departmentId);
    appendIfValue('departmentId', formData.departmentId);
    appendIfValue('designation_id', formData.designationId);
    appendIfValue('designationId', formData.designationId);
    appendIfValue('blood_group', formData.bloodGroup);
    appendIfValue('bloodGroup', formData.bloodGroup);
    appendIfValue('emergency_no_1', formData.emergencyNo1);
    appendIfValue('emergencyNo1', formData.emergencyNo1);
    appendIfValue('emergency_no_2', formData.emergencyNo2);
    appendIfValue('emergencyNo2', formData.emergencyNo2);
    appendIfValue('address', formData.address);
    appendIfValue('city', formData.city);
    appendIfValue('province', formData.state);
    appendIfValue('country', formData.country);
    appendIfValue('zipcode', formData.zipcode);
    appendIfValue('bank', formData.bankName);
    appendIfValue('bankName', formData.bankName);
    appendIfValue('bank_code', formData.bankCode);
    appendIfValue('bank_branch', formData.bankBranch);
    appendIfValue('bank_branch_code', formData.bankBranchCode);
    appendIfValue('branch_code', formData.bankBranchCode);
    appendIfValue('account_holder', formData.accountHolderName);
    appendIfValue('accountHolderName', formData.accountHolderName);
    appendIfValue('account_number', formData.accountNumber);
    appendIfValue('accountNumber', formData.accountNumber);
    appendIfValue('password', formData.password);

    appendIfValue('branch', formData.branch);
    appendIfValue('employee_type', formData.employeeType);
    appendIfValue('pay_frequency', formData.payFrequency);

    if (formData.profilePicture) {
      formDataToSend.append('profilePicture', formData.profilePicture);
    }

    try {
      const response = await updateEmployee(selectedEmployeeId,formDataToSend);
      console.log('Employee updated:', response);
      if(response){
          toast.success("Employee updated successfully");
          navigate(route.employeegrid);
      }
      //if response.status = sucess then route to main veiw
    } catch (error) {
      console.error('Error creating employee:', error);
      toast.error(error.message || "Failed to update employee");
    }
    
  };

  return (
    <div>
      <div className="page-wrapper">
         <ToastContainer />
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Edit Employee</h4>
                <h6>Edit Employee</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <div className="page-btn">
                  <Link to={route.employeegrid} className="btn btn-secondary">
                    <ArrowLeft className="me-2" />
                    Back to Employee List
                  </Link>
                </div>
              </li>

              <li>
                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={data ? "active" : ""}
                    onClick={() => {
                      dispatch(setToogleHeader(!data));
                    }}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>
          {/* /product list */}
          <form onSubmit={handleSubmit}>
            <div className="card">
              <div className="card-body">
                <div className="new-employee-field">
                  <div className="card-title-head">
                    <h6>
                      <span>
                        <Info className="feather-edit" />
                      </span>
                      Employee Information
                    </h6>
                  </div>
                  <div className="profile-pic-upload">
                    <div className="profile-pic">
                      <span>
                        <PlusCircle className="plus-down-add" />
                        Profile Photo
                      </span>
                    </div>
                    <div className="input-blocks mb-0">
                      <div className="image-upload mb-0">
                        <input 
                          type="file"
                          name="profilePicture" 
                          onChange={handleChange} 
                          accept="image/*" 
                          // value={formData.profilePicture}
                        />
                        <div className="image-uploads">
                          <h4>Change Image</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">First Name</label>
                        <input 
                          type="text" 
                          className="form-control"
                          name="firstName" 
                          value={formData.firstName} 
                          onChange={(event) => handleChange(event, 'firstName')}  
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Last Name</label>
                        <input 
                          type="text" 
                          className="form-control"
                          name="lastName" 
                          value={formData.lastName} 
                          onChange={(event) => handleChange(event, 'lastName')}  
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Email</label>
                        <input 
                          type="email" 
                          className="form-control"
                          name="email" 
                          value={formData.email} 
                          onChange={handleChange}  
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Contact Number</label>
                        <input 
                          type="text" 
                          className="form-control"
                          name="contactNumber" 
                          value={formData.contactNumber} 
                          onChange={handleChange}  
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Emp Code</label>
                        <input 
                          type="text" 
                          className="form-control"
                          name="epfNumber" 
                          value={formData.epfNumber} 
                          onChange={handleChange}  
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">NIC</label>
                        <input 
                          type="text" 
                          className="form-control"
                          name="nic" 
                          value={formData.nic} 
                          onChange={handleChange}  
                          placeholder="Enter NIC"
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="input-blocks">
                        <label>Date of Birth</label>
                        <div className="input-groupicon calender-input">
                          <DatePicker
                            value={formData.dateOfBirth ? dayjs(formData.dateOfBirth) : null}
                            onChange={(date, dateString) => handleDateChange(date, dateString, 'dateOfBirth')}
                            // selected={formData.dateOfBirth}
                            // defaultValue={dayjs(formData.dateOfBirth, 'YYYY-MM-DD' )}
                            // onChange={(date) => setFormData({ ...formData, dateOfBirth: date })}
                            type="date"
                            className="filterdatepicker"
                            dateFormat="dd-MM-yyyy"
                            placeholder="Select Date of Birth"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Gender *</label>
                        <div style={errBorder('gender')}>
                          <Select
                            name="gender"
                            value={gender.find(option => option.value.toLowerCase() === formData.gender?.toLowerCase())}
                            onChange={(selectedOption) => handleSelectChange(selectedOption, 'gender')}
                            className="select"
                            options={gender}
                            placeholder="Select Gender"
                          />
                        </div>
                        {errors.gender && <div className="invalid-feedback" style={{ display: 'block' }}>{errors.gender}</div>}
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Nationality</label>

                        <Select
                          name="nationality"
                          value={nationality.find(option => option.value === formData.nationality)} 
                          onChange={(selectedOption) => handleSelectChange(selectedOption, 'nationality')}
                          className="select"
                          options={nationality}
                          placeholder="Select Nationality"
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="input-blocks">
                        <label>Joining Date</label>
                        <div className="input-groupicon calender-input">
                          <DatePicker
                            value={formData.joiningDate ? dayjs(formData.joiningDate) : null}
                            onChange={(date, dateString) => handleDateChange(date, dateString, 'joiningDate')}
                            // selected={formData.joiningDate}
                            // defaultValue={dayjs(formData.joiningDate, 'YYYY-MM-DD')}
                            // onChange={(date) => setFormData({ ...formData, joiningDate: date })}
                            type="date"
                            className="filterdatepicker"
                            dateFormat="dd-MM-yyyy"
                            placeholder="Select Joining Date"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <div className="add-newplus">
                          <label className="form-label">Shift</label>
                          <Link to="#">
                            <span>
                              <PlusCircle className="plus-down-add" />
                              Add new
                            </span>
                          </Link>
                        </div>

                        <Select
                          className="select"
                          value={shifts.find(option => option.value === formData.shiftId) || null}
                          options={shifts}
                          placeholder="Select Shift"
                          onChange={(selectedOption) => handleSelectChange(selectedOption, 'shiftId')}
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Department</label>

                        <Select
                          className="select"
                          value={departments.find(option => option.value === formData.departmentId)}
                          options={departments}
                          placeholder="Select Department"
                          onChange={(selectedOption) => handleSelectChange(selectedOption, 'departmentId')}
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Designation</label>

                        <Select
                          className="select"
                          value={designation.find(option => option.value === formData.designationId)}
                          options={designation}
                          placeholder="Select Designation"
                          onChange={(selectedOption) => handleSelectChange(selectedOption, 'designationId')}
                        />
                      </div>
                    </div>

                    {/* Branch — Mandatory */}
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Branch *</label>
                        <div style={errBorder('branch')}>
                          <Select
                            className="select"
                            value={branchOptions.find(o => o.value === formData.branch) || null}
                            options={branchOptions}
                            placeholder="Select Branch"
                            onChange={(selectedOption) => handleSelectChange(selectedOption, 'branch')}
                          />
                        </div>
                        {errors.branch && <div className="invalid-feedback" style={{ display: 'block' }}>{errors.branch}</div>}
                      </div>
                    </div>

                    {/* Employee Type — Mandatory */}
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Employee Type *</label>
                        <div style={errBorder('employeeType')}>
                          <Select
                            className="select"
                            value={employeeTypeOptions.find(o => o.value === formData.employeeType) || null}
                            options={employeeTypeOptions}
                            placeholder="Select Employee Type"
                            onChange={(selectedOption) => handleSelectChange(selectedOption, 'employeeType')}
                          />
                        </div>
                        {errors.employeeType && <div className="invalid-feedback" style={{ display: 'block' }}>{errors.employeeType}</div>}
                      </div>
                    </div>

                    {/* Pay Frequency — Mandatory */}
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Pay Frequency *</label>
                        <div style={errBorder('payFrequency')}>
                          <Select
                            className="select"
                            value={payFrequencyOptions.find(o => o.value === formData.payFrequency) || null}
                            options={payFrequencyOptions}
                            placeholder="Select Pay Frequency"
                            onChange={(selectedOption) => handleSelectChange(selectedOption, 'payFrequency')}
                          />
                        </div>
                        {errors.payFrequency && <div className="invalid-feedback" style={{ display: 'block' }}>{errors.payFrequency}</div>}
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Blood Group</label>
                        <Select
                          name="bloodGroup"
                          value={bloodgroup.find(option => option.value === formData.bloodGroup)} 
                          onChange={(selectedOption) => handleSelectChange(selectedOption, 'bloodGroup')}
                          className="select"
                          options={bloodgroup}
                          placeholder="Select Blood Group"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="other-info">
                    <div className="card-title-head">
                      <h6>
                        <span>
                          <Info className="feather-edit" />
                        </span>
                        Other Information
                      </h6>
                    </div>
                    <div className="row">
                      <div className="col-lg-4 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Emergency No 1</label>
                          <input 
                            type="text"   
                            className="form-control" 
                            name="emergencyNo1" 
                            value={formData.emergencyNo1} 
                            onChange={handleChange} 
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Emergency No 2</label>
                          <input 
                            type="text"   
                            className="form-control" 
                            name="emergencyNo2" 
                            value={formData.emergencyNo2} 
                            onChange={handleChange} 
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6"></div>
                      <div className="col-lg-4 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Address</label>
                          <input 
                            type="text"   
                            className="form-control" 
                            name="address" 
                            value={formData.address} 
                            onChange={handleChange} 
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Country</label>

                          <Select
                            name="country"
                            value={country.find(option => option.value === formData.country)} 
                            onChange={(selectedOption) => handleSelectChange(selectedOption, 'country')}
                            className="select"
                            options={country}
                            placeholder="Select Country"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">State</label>
                          <input 
                            type="text"   
                            className="form-control" 
                            name="state" 
                            value={formData.state} 
                            onChange={handleChange} 
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">City</label>
                          <input 
                            type="text"   
                            className="form-control" 
                            name="city" 
                            value={formData.city} 
                            onChange={handleChange} 
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Zipcode</label>
                          <input 
                            type="text"   
                            className="form-control" 
                            name="zipcode" 
                            value={formData.zipcode} 
                            onChange={handleChange} 
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-title-head">
                    <h6>
                      <span>
                        <Info className="feather-edit" />
                      </span>
                      Bank Details
                    </h6>
                  </div>
                  <div className="row">
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Bank Name</label>
                        <input 
                          type="text"   
                          className="form-control" 
                          name="bankName" 
                          value={formData.bankName} 
                          onChange={handleChange} 
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Bank Code</label>
                        <input 
                          type="text"   
                          className="form-control" 
                          name="bankCode" 
                          value={formData.bankCode} 
                          onChange={handleChange} 
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Bank Branch</label>
                        <input 
                          type="text"   
                          className="form-control" 
                          name="bankBranch" 
                          value={formData.bankBranch} 
                          onChange={handleChange} 
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Bank Branch Code</label>
                        <input 
                          type="text"   
                          className="form-control" 
                          name="bankBranchCode" 
                          value={formData.bankBranchCode} 
                          onChange={handleChange} 
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Account Holder Name</label>
                        <input 
                          type="text"   
                          className="form-control" 
                          name="accountHolderName" 
                          value={formData.accountHolderName} 
                          onChange={handleChange} 
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Account Number</label>
                        <input 
                          type="text"   
                          className="form-control" 
                          name="accountNumber" 
                          value={formData.accountNumber} 
                          onChange={handleChange} 
                        />
                      </div>
                    </div>
                  </div>
                  <div className="pass-info">
                    <div className="card-title-head">
                      <h6>
                        <span>
                          <Info />
                        </span>
                        Password
                      </h6>
                    </div>
                    <div className="row">
                      <div className="col-lg-4 col-md-6">
                        <div className="input-blocks mb-md-0 mb-sm-3">
                          <label>Password</label>
                          <div className="pass-group">
                          <input
                              type={showPassword ? "text" : "password"}
                              className="pass-input"
                              placeholder="Enter your password"
                              value={formData.password}
                              onChange={handlePasswordChange}
                            />
                            <span
                              className={`fas toggle-password ${
                                showPassword ? "fa-eye" : "fa-eye-slash"
                              }`}
                              onClick={handleTogglePassword}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <div className="input-blocks mb-0">
                          <label>Confirm Password</label>
                          <div className="pass-group">
                            <input
                              type={showConfirmPassword ? "text" : "password"}
                              className="pass-input"
                              placeholder="Enter your password"
                              defaultValue={formData.password}
                              value={confirmPassword}
                              onChange={handleConfirmPasswordChange}
                              // onChange={handleConfirmPasswordChange}
                            />
                            <span
                              className={`fas toggle-password ${
                                showConfirmPassword ? "fa-eye" : "fa-eye-slash"
                              }`}
                              onClick={handleToggleConfirmPassword}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {!passwordsMatch && <p style={{ color: 'red' }}>Passwords do not match!</p>}
                  </div>
                </div>
              </div>
            </div>
            {/* /product list */}
            <div className="text-end mb-3">
              <button type="button" className="btn btn-cancel me-2">
                Cancel
              </button>
              <button to="#" className="btn btn-submit">
                Save Product
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditEmployee;
